"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var ReleaseState_1 = require("../../../release/model/ReleaseState");

var SelloutType_1 = require("../SelloutType");
/**
 * @author Adam Drda
 */


var SelloutIdentificationDetailDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutIdentificationDetailDTO, _DomainObject_1$Domai);

  function SelloutIdentificationDetailDTO(productId, productName, productExternalId, siteId, siteName, releaseName, releaseState, selloutType, selloutVolume, selloutPrice, stockValue, daysLeft, endDate, estimationInPercent) {
    var _this;

    _classCallCheck(this, SelloutIdentificationDetailDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationDetailDTO).call(this));
    _this.productId = productId;
    _this.productName = productName;
    _this.productExternalId = productExternalId;
    _this.siteId = siteId;
    _this.siteName = siteName;
    _this.releaseName = releaseName;
    _this.releaseState = releaseState;
    _this.selloutType = selloutType;
    _this.selloutVolume = selloutVolume;
    _this.selloutPrice = selloutPrice;
    _this.stockValue = stockValue;
    _this.daysLeft = daysLeft;
    _this.endDate = endDate;
    _this.estimationInPercent = estimationInPercent;
    return _this;
  }

  return SelloutIdentificationDetailDTO;
}(DomainObject_1.DomainObject);

exports.SelloutIdentificationDetailDTO = SelloutIdentificationDetailDTO;

SelloutIdentificationDetailDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutIdentificationDetailDTO.name);
  return {
    productId: builder.str('productId'),
    productName: builder.str('productName'),
    productExternalId: builder.opt(builder.str('productExternalId')),
    siteId: builder.str('siteId'),
    siteName: builder.str('siteName'),
    releaseName: builder.opt(builder.str('releaseName')),
    releaseState: builder.opt(builder.senum('releaseState', ReleaseState_1.ReleaseState, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseState)),
    selloutType: builder.senum('selloutType', SelloutType_1.SelloutType, CodebookLookupSequence_1.CodebookLookupSequence.SelloutType),
    selloutVolume: builder.opt(builder.bigNum('selloutVolume')),
    selloutPrice: builder.opt(builder.bigNum('selloutPrice')),
    stockValue: builder.opt(builder.bigNum('stockValue')),
    daysLeft: builder.opt(builder.num('daysLeft')),
    endDate: builder.opt(builder.date('endDate', DateParser_1.DateParser.ISO_PATTERN)),
    estimationInPercent: builder.opt(builder.bigNum('estimationInPercent'))
  };
}();